// Fallback data in case API fails
const fallbackData = {
  rating: 4.8,
  totalRatings: 75,
  reviews: [
    {
      id: 'review1',
      author_name: 'Samantha Perera',
      rating: 5,
      text: 'Amazing service! The staff is very professional and friendly. Best salon experience in Kandy.',
      time: new Date().getTime() / 1000 - 86400,
      profile_photo_url:
        'https://ui-avatars.com/api/?name=SP&background=random',
    },
    {
      id: 'review2',
      author_name: 'Ashan Fernando',
      rating: 5,
      text: 'Excellent hair treatments and very skilled staff. Highly recommended for anyone looking for quality service.',
      time: new Date().getTime() / 1000 - 172800,
      profile_photo_url:
        'https://ui-avatars.com/api/?name=AF&background=random',
    },
    {
      id: 'review3',
      author_name: 'Dilini Silva',
      rating: 4,
      text: 'Great ambiance and professional service. The staff is well trained and friendly.',
      time: new Date().getTime() / 1000 - 259200,
      profile_photo_url:
        'https://ui-avatars.com/api/?name=DS&background=random',
    },
    {
      id: 'review4',
      author_name: 'Kavindi Silva',
      rating: 5,
      text: 'Excellent service and very professional staff. The ambiance is great and relaxing.',
      time: new Date().getTime() / 1000 - 345600,
      profile_photo_url:
        'https://ui-avatars.com/api/?name=KS&background=random',
    },
    {
      id: 'review5',
      author_name: 'Nuwan Perera',
      rating: 5,
      text: 'Best salon in Kandy! Very skilled staff and great attention to detail.',
      time: new Date().getTime() / 1000 - 432000,
      profile_photo_url:
        'https://ui-avatars.com/api/?name=NP&background=random',
    },
  ],
};

export const fetchGoogleReviews = async () => {
  // Return all reviews instead of filtering
  return fallbackData;

  /* TODO: Implement with backend proxy
  try {
    const response = await fetch(
      `/api/google-places?placeId=${PLACE_ID}`,
      {
        headers: {
          'Accept': 'application/json'
        }
      }
    );
    const data = await response.json();
    return {
      reviews: data.result.reviews || fallbackData.reviews,
      rating: data.result.rating || fallbackData.rating,
      totalRatings: data.result.user_ratings_total || fallbackData.totalRatings,
    };
  } catch (error) {
    console.error('Error fetching Google reviews:', error);
    return fallbackData;
  }
  */
};
